// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kjFusJfImwshiCY324Ho {
    align-items: flex-start;
    color: #666;
    display: flex;
    font-size: 13px;
    line-height: 1.5;
    margin: 6px 0;
    min-height: 54px;
    padding: 15px 0;
}

.kjFusJfImwshiCY324Ho:last-child {
    border-bottom: 1px solid #ccc;
}

@media (max-width: 695px) {
    .kjFusJfImwshiCY324Ho {
        display: block;
    }
}

.kjFusJfImwshiCY324Ho+.kjFusJfImwshiCY324Ho {
    border-top: 1px solid #ccc;
}

.a6nrmfbVMgNVK0YraahS {
    margin-right: 16px;
}

.WUwvSM8mouMi79_XyMH4 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
}

.nQBkrSM3EPPKPdz0kAj6 {
    padding-left: 16px;
}

.Tg6XgbOMcmQvzHCo_hQ_ {
    font-weight: 600;
}

.CBmyEv_OjPfuUrDXXaNo {
    padding-left: 8px;
}

.fZ_3Gc4iwM1fwCaL5Vg3 {
    align-self: center;
    margin-left: auto;
}

.L_EZfjM_y2cfK_8oz64Z {
    margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/clients/interests/list/interests.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".record {\n    align-items: flex-start;\n    color: #666;\n    display: flex;\n    font-size: 13px;\n    line-height: 1.5;\n    margin: 6px 0;\n    min-height: 54px;\n    padding: 15px 0;\n}\n\n.record:last-child {\n    border-bottom: 1px solid #ccc;\n}\n\n@media (max-width: 695px) {\n    .record {\n        display: block;\n    }\n}\n\n.record+.record {\n    border-top: 1px solid #ccc;\n}\n\n.info {\n    margin-right: 16px;\n}\n\n.propertyName {\n    color: #333;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.applicationDate {\n    padding-left: 16px;\n}\n\n.statusLabel {\n    font-weight: 600;\n}\n\n.statusValue {\n    padding-left: 8px;\n}\n\n.update {\n    align-self: center;\n    margin-left: auto;\n}\n\n.remove {\n    margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"record": `kjFusJfImwshiCY324Ho`,
	"info": `a6nrmfbVMgNVK0YraahS`,
	"propertyName": `WUwvSM8mouMi79_XyMH4`,
	"applicationDate": `nQBkrSM3EPPKPdz0kAj6`,
	"statusLabel": `Tg6XgbOMcmQvzHCo_hQ_`,
	"statusValue": `CBmyEv_OjPfuUrDXXaNo`,
	"update": `fZ_3Gc4iwM1fwCaL5Vg3`,
	"remove": `L_EZfjM_y2cfK_8oz64Z`
};
export default ___CSS_LOADER_EXPORT___;
